export default "__VITE_PUBLIC_ASSET__c4424208__"